import React, { MouseEvent } from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { Button } from '@eika/button';
import { CheckmarkAnimation } from '@eika/checkmark-animation';
import { TrashcanAnimation } from '@eika/trashcan-animation';

import useTranslation from '../../hooks/useTranslation';
import { useSigningContext } from '../../signingContext/signingContext';
import { Content } from '../shared/Content';
import { ErrorCardWrapper } from '../shared/ErrorCardWrapper';
import { ReceiverAction } from './form/state';

interface Props {
    action: ReceiverAction;
    retryChange: (event: MouseEvent<HTMLButtonElement>) => void;
    retryDelete: (event: MouseEvent<HTMLButtonElement>) => void;
    deleteError: RequestExceptionWithResponse | null;
}

const ResultDialog: React.FC<Props> = ({ action, retryChange, retryDelete, deleteError }) => {
    const translated = useTranslation();
    const { signingError, signingStatus } = useSigningContext();

    switch (action) {
        case 'edit': {
            switch (signingStatus) {
                case 'COMPLETED':
                    return (
                        <div className="receiver__success">
                            <CheckmarkAnimation />
                            <h2>{translated.receiverIsUpdated}</h2>
                        </div>
                    );
                default:
                    return (
                        <Content>
                            <ErrorCardWrapper
                                title={translated.errors.somethingWentWrongChangingReceiver}
                                exception={signingError}
                                isModal
                            >
                                <Button onClick={retryChange}>{translated.tryAgain}</Button>
                            </ErrorCardWrapper>
                        </Content>
                    );
            }
        }
        case 'delete': {
            if (deleteError) {
                return (
                    <Content>
                        <ErrorCardWrapper
                            title={translated.errors.somethingWentWrongDeletingReceiver}
                            exception={deleteError}
                            isModal
                        >
                            <Button onClick={retryDelete}>{translated.tryAgain}</Button>
                        </ErrorCardWrapper>
                    </Content>
                );
            }
            return (
                <div className="receiver__success">
                    <TrashcanAnimation />
                    <h2>{translated.receiverIsDeleted}</h2>
                </div>
            );
        }
        default:
            return <></>;
    }
};

export default ResultDialog;
